import { useTranslation } from "react-i18next";

function countWords(s) {
  const t = s.trim();
  if (!t) return 0;
  return t.split(/\s+/).filter(Boolean).length;
}

export function EditorStatusBar({ text }) {
  const { i18n, t } = useTranslation();
  const words = countWords(text);
  const chars = text.length;
  const lines = text === "" ? 0 : text.split(/\r?\n/).length;
  const loc = i18n.language?.startsWith("ar") ? "ar" : "en";

  return (
    <div className="editor-status-bar" role="status" aria-live="polite">
      <span>
        <strong>{words.toLocaleString(loc)}</strong> {t("mdwriter.words")}
      </span>
      <span className="editor-status-bar__sep" aria-hidden="true">
        ·
      </span>
      <span>
        <strong>{chars.toLocaleString(loc)}</strong> {t("mdwriter.characters")}
      </span>
      <span className="editor-status-bar__sep" aria-hidden="true">
        ·
      </span>
      <span>
        <strong>{lines.toLocaleString(loc)}</strong> {t("mdwriter.lines")}
      </span>
    </div>
  );
}
